export const urlToEndpointId = url =>
  url
    .replace(/^https?:\/\//, '')
    .replace(/\/$/, '')
    .replace(/\//g, '\\');

export const endpointIdToUrl = endpointId => endpointId.replace(/\\/g, '/');
